import {Injectable} from "@angular/core";

@Injectable()
export class NavigationParams {

    constructor(private params: any = {}) {
    }

    public get(param: string) {
        return this.params[param];
    }
}


// WEBPACK FOOTER //
// ./src/app/orchestration/navigation-params.ts